import { Box } from '@mui/material';

export default function ClearBoxCarousel({ imageSources, activeImageIndex, onChangeActiveImage }) {
    return (
        <Box
            sx={{
                display: 'flex',
                height: '100%',
                overflow: 'hidden',
            }}
        >
            {/* Vertical thumbnails */}
            <Box
                sx={{
                    width: 96,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    py: 2,
                    gap: 1.5,
                }}
            >
                {imageSources.map((image, index) => (
                    <Box
                        key={index}
                        onClick={() => onChangeActiveImage(index)}
                        sx={{
                            width: 72,
                            height: 72,
                            borderRadius: 2,
                            overflow: 'hidden',
                            cursor: 'pointer',
                            border:
                                activeImageIndex === index
                                    ? '2px solid var(--primary-color)'
                                    : '1px solid rgba(0,0,0,0.08)',
                            opacity: activeImageIndex === index ? 1 : 0.7,
                            transition: 'var(--transition)',
                            '&:hover': {
                                opacity: 1,
                                transform: 'translateY(-2px)',
                            },
                        }}
                    >
                        <img
                            src={image.src}
                            alt={image.alt}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                            }}
                        />
                    </Box>
                ))}
            </Box>

            {/* Main image */}
            <Box
                sx={{
                    flex: 1,
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: { xs: 2, md: 4 },
                }}
            >
                <img
                    src={imageSources[activeImageIndex].src}
                    alt={imageSources[activeImageIndex].alt}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        width: 'auto',
                        height: 'auto',
                        objectFit: 'contain',
                    }}
                />
            </Box>
        </Box>
    );
}
